import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store'
import { Permission } from '@/app/pages/providers/admin-auth-guard'

export type Roles = 'admin' | 'program_manager'

export const useHasRequiredPermissions = (
  requiredPermissions: Permission[]
) => {
  const privileges = useSelector((state: RootState) => state.auth.privileges)

  return requiredPermissions.some((permission) =>
    privileges.includes(permission)
  )
}
